import type { PropsWithChildren } from "react";
import { Component } from "react";

import { Fallback } from "router/Fallback";

type State = { hasError: boolean };

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError = () => ({ hasError: true });

  override render = () => (this.state.hasError ? <Fallback error /> : this.props.children);
}
